
import { defineComponent } from 'vue'
import IconsSprite from '@/components/IconsSprite.vue'
import ALoader from '@/components/ALoader.vue'
import useConfiguration from './composables/configuration/configuration'
import useCurrentUser from '@/composables/user/user'
import useAppState, { ViewType } from '@/composables/ui/ui'
import ProfileCrossroads from '@/components/Profile/ProfileCrossroads.vue'
import ErrorPage from '@/components/ErrorPage.vue'
import useTopic from '@/composables/topic/topic'
import UserProfile from '@/components/Profile/UserProfile.vue'
import TechnicalShutdown from '@/components/TechnicalShutdown.vue'
import PostList from '@/components/Post/PostList.vue'
import PostSimpleList from '@/components/Post/PostSimpleList.vue'
import useScrollManager from '@/composables/scroller/useScrollManager'

// eslint-disable-next-line @typescript-eslint/camelcase
declare let __webpack_public_path__: string

export default defineComponent({
  name: 'App',
  components: {
    PostSimpleList,
    TechnicalShutdown,
    ErrorPage,
    ProfileCrossroads,
    PostList,
    UserProfile,
    IconsSprite,
    ALoader,
  },
  data() {
    return {
      PROFILE: ViewType.PROFILE,
      TOP_NEWEST: ViewType.TOP_NEWEST,
      PROFILE_USER_EDIT: ViewType.PROFILE_USER_EDIT,
      PROFILE_EMAIL_EDIT: ViewType.PROFILE_EMAIL_EDIT,
      WIDGET_DISABLED: ViewType.WIDGET_DISABLED,
    }
  },
  setup() {
    const {
      currentUser,
      isLoggedIn,
      isSubscriber,
      allowPayingCustomerAction,
      userEnsured,
    } = useCurrentUser()
    const { ensureCurrentUser } = useCurrentUser()
    const { configuration } = useConfiguration()

    ensureCurrentUser()
    const { loadTopic, topic } = useTopic()

    if (configuration.widget.topicId > 0) {
      loadTopic()
    }

    useScrollManager()

    let publicPath = configuration.envConf.widgetUrl
    if (process.env.VUE_APP_VERSION) {
      publicPath += process.env.VUE_APP_VERSION + '/'
    }
    // eslint-disable-next-line @typescript-eslint/camelcase,prefer-const
    __webpack_public_path__ = publicPath

    return {
      currentUser,
      configuration,
      isLoggedIn,
      allowPayingCustomerAction,
      isSubscriber,
      userEnsured,
      topic,
      ...useAppState(),
    }
  },
})
